import React from 'react';
import { Trans } from '@lingui/macro';

import { PrivacyOptions } from '@rover/icons';
import { Box, Link, Text } from '@rover/kibble/core';
import fireDataLayerEvent from '@rover/utilities/fireDataLayerEvent';

const CookieConsentLink = (): JSX.Element => (
  <Box mt="4x" width="100%">
    <Link
      variant="secondary"
      underline={false}
      href="/terms/privacy/#preferences"
      rel="nofollow"
      onClick={() =>
        fireDataLayerEvent({
          event: 'cookie-consent-footer-your-privacy-choices',
        })
      }
    >
      <PrivacyOptions alt="" />

      <Text ml="1x" size="100">
        <Trans>Your privacy choices</Trans>
      </Text>
    </Link>
  </Box>
);

export default CookieConsentLink;
